import { CheckCircleFilled, ExclamationCircleFilled, QuestionCircleFilled } from '@ant-design/icons';
import { Modal, Space } from 'antd';
import React from 'react';

export const ConfirmationModal = ({
  isOpen,
  toggle,
  onClick,
  headerText,
  bodyText,
  confirmButtonText,
  cancelButtonText,
  actionType,
}) => {
  let iconComponent;

  // Determine which icon to use based on actionType
  if (actionType === 'progress') {
    iconComponent = <CheckCircleFilled />;
  } else if (actionType === 'delete') {
    iconComponent = <ExclamationCircleFilled />;
  } else if (actionType === 'warning') {
    iconComponent = <QuestionCircleFilled />;
  }

  return (
    <Modal
      open={isOpen}
      className={`ant-modal-${actionType}`}
      title={
        <Space>
          {iconComponent}
          {headerText}
        </Space>
      }
      onOk={onClick}
      onCancel={toggle}
      zIndex={99999}
      footer={
        <div className='d-flex justify-content-end'>
          <button className='btn btn-modal-cancel me-2' onClick={toggle}>
            {cancelButtonText}
          </button>
          <button className={`btn btn-modal-${actionType} me-2`} onClick={onClick}>
            {confirmButtonText}
          </button>
        </div>
      }
    >
      <span className='mb-4'>{bodyText}</span>
    </Modal>
  );
};
